<!-- <div class="project-actions" *ngIf="actions.length > 0">
    <button mat-stroked-button [matMenuTriggerFor]="projectActionsMenu" class="actions-trigger">
        <span>{{ menuLabel }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #projectActionsMenu="matMenu">
        <ng-container *ngFor="let action of actions">
            <button mat-menu-item *ngIf="actionVisible(action)" [disabled]="actionDisabled(action)"
                (click)="runAction(action, $event)">
                {{ action.label }}
            </button>
        </ng-container>
    </mat-menu>
</div> -->
<div class="project-actions" *ngIf="actions.length > 0">
    <button mat-stroked-button [matMenuTriggerFor]="projectActionsMenu" class="actions-trigger">

        <span class="button-content">
            <span class="button-label">{{ menuLabel }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </span>

    </button>

    <mat-menu #projectActionsMenu="matMenu">
        <ng-container *ngFor="let action of actions">
            <button mat-menu-item *ngIf="actionVisible(action)" [disabled]="actionDisabled(action)"
                (click)="runAction(action, $event)">
                {{ action.label }}
            </button>
        </ng-container>
    </mat-menu>
</div>